import { pickBy } from '@/utils'
import AttrItem from  "./attr-item.vue"
const config = {
  name: 'HmCollections',
  setting: [
    {
      label: '标题',
      key: 'title',
      component: 'input',
      value: '标题'
    },
    {
      label: '商品',
      key: 'goods',
      component: function (h, { key }) {
        return <AttrItem v-model={this.value[key]} />
      },
      value: [
        {
          imgUrl: '',
          urlData: {},
          title: '商品标题',
          subtitle: '商品副标题',
          id: ''
        },
        {
          imgUrl: '',
          urlData: {},
          title: '商品标题',
          subtitle: '商品副标题',
          id: ''
        },
        {
          imgUrl: '',
          urlData: {},
          title: '商品标题',
          subtitle: '商品副标题',
          id: ''
        },
        {
          imgUrl: '',
          urlData: {},
          title: '商品标题',
          subtitle: '商品副标题',
          id: ''
        }
      ]
    }
  ]
}
export default config
